import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import {
  Typography, DatePicker, Select, List, Tag, Divider, Space, Statistic, Row, Col,
} from 'antd';
import { useExpenses } from 'hooks/api';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

const ExpenseList = () => {
  const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null] | null>(null);
  const [sort, setSort] = useState<'asc' | 'desc'>('desc');

  const params = {
    dateFrom: dateRange?.[0]?.startOf('day').toISOString(),
    dateTo: dateRange?.[1]?.endOf('day').toISOString(),
    sort,
  };

  const { data, isLoading } = useExpenses(params);

  const expenses: any[] = data?.expenses || [];
  const total: number = data?.total || 0;

  return (
    <div>
      <Title level={2}>Витрати</Title>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col>
          <Space direction='vertical' size={4}>
            <Text type='secondary'>Період</Text>
            <RangePicker
              onChange={(dates) => setDateRange(dates as [Dayjs | null, Dayjs | null] | null)}
              format='DD.MM.YYYY'
            />
          </Space>
        </Col>
        <Col>
          <Space direction='vertical' size={4}>
            <Text type='secondary'>Сортування</Text>
            <Select value={sort} onChange={setSort} style={{ width: 160 }}>
              <Option value='desc'>Спочатку нові</Option>
              <Option value='asc'>Спочатку старі</Option>
            </Select>
          </Space>
        </Col>
      </Row>

      <List
        loading={isLoading}
        dataSource={expenses}
        locale={{ emptyText: 'Витрат не знайдено' }}
        renderItem={(item: any) => (
          <List.Item>
            <List.Item.Meta
              title={(
                <Space>
                  <Text strong>
                    {item.amount}
                    {' '}
                    грн
                  </Text>
                  {item.person && <Tag color='blue'>{item.person}</Tag>}
                  {!item.person && <Tag color='default'>Не вказано</Tag>}
                </Space>
              )}
              description={(
                <Space direction='vertical' size={2}>
                  {item.description && <Text type='secondary'>{item.description}</Text>}
                  <Text type='secondary' style={{ fontSize: 12 }}>
                    {dayjs(item.createdAt).format('DD.MM.YYYY HH:mm')}
                  </Text>
                </Space>
              )}
            />
          </List.Item>
        )}
      />

      <Divider />

      <Statistic
        title={dateRange ? 'Сума за обраний період' : 'Загальна сума всіх витрат'}
        value={total}
        suffix='грн'
      />
    </div>
  );
};

export default ExpenseList;
